import React from 'react';

const Logo = ({ className = "" }) => {
  return (
    <div className={`font-bold text-2xl tracking-tight ${className}`}>
      <span className="text-white">Wealth</span>
      <span className="text-[#F59E0B] relative">
        Optimizers
        <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]"></span>
      </span>
    </div>
  );
};

export default Logo;
